/**
 * StatsGrid Component
 *
 * Grid layout for displaying multiple StatsCards with:
 * - Configurable column count
 * - Responsive grid layout
 * - Consistent spacing
 * - Loading state support
 */

import { ReactNode } from 'react'
import { cn } from '@/lib/utils'

export interface StatsGridProps {
  children: ReactNode
  columns?: 1 | 2 | 3 | 4
  className?: string
}

export function StatsGrid({ children, columns = 4, className }: StatsGridProps) {
  const gridClass = {
    1: 'grid-cols-1',
    2: 'md:grid-cols-2',
    3: 'md:grid-cols-2 lg:grid-cols-3',
    4: 'md:grid-cols-2 lg:grid-cols-4',
  }[columns]

  return (
    <div className={cn('grid gap-4', gridClass, className)}>
      {children}
    </div>
  )
}
